import { z } from 'zod';
import { ReleaseStatus } from '@graphql/reactQuery';

const AllReleaseStatus = {
  All: 'ALL_AVAILABILITY',
  ...ReleaseStatus,
} as const;

const AllFeaturedStatus = {
  All: 'ALL_DROPS',
  Hot: 'HOT',
  Following: 'FOLLOWING',
} as const;

export const ReleaseStatusEnum = z.nativeEnum(AllReleaseStatus);
export type ReleaseStatusEnum = z.infer<typeof ReleaseStatusEnum>;

export const FeaturedStatusEnum = z.nativeEnum(AllFeaturedStatus);
export type FeaturedStatusEnum = z.infer<typeof FeaturedStatusEnum>;

const UpcomingStatus = z.object({
  featuredStatus: FeaturedStatusEnum,
  scrollIndex: z.number(),
});
export type UpcomingStatus = z.infer<typeof UpcomingStatus>;

const RecentStatus = z.object({
  featuredStatus: FeaturedStatusEnum,
  releaseStatus: ReleaseStatusEnum,
  scrollIndex: z.number(),
});
export type RecentStatus = z.infer<typeof RecentStatus>;

export const ReleaseFilterStatusSchema = z.object({
  upcoming: UpcomingStatus,
  recent: RecentStatus,
});

export type ReleaseFilterStatusState = z.infer<typeof ReleaseFilterStatusSchema>;
